import React, { useState, useEffect, useRef } from 'react';
import PaginationLicense from './PaginationLicense';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import routes from '../libs/routes';

function ProductBox({
    licenseGroup = [],
    groupName = '',
    organization = null,
    initialBoxView = false,
    payList = [],
    subscribelist = [],
    view = 0,
    payinfolists=()=>{}
}) {
    const lang = useSelector(state => state.langReducer.lang);

    // 드롭다운 기본 텍스트는 lang에 따라 변경되도록 useEffect에서 업데이트
    const [dropLicense, setDropLicense] = useState(lang === 0 ? "라이선스 상태" : "License Status");
    const [dropNumber, setDropNumber] = useState(lang === 0 ? "라이선스 no" : "License no.");
    const [dropGroup, setDropGroup] = useState(lang === 0 ? "조직 전체" : "All Organizations");

    useEffect(() => {
        setDropLicense(lang === 0 ? "라이선스 상태" : "License Status");
        setDropNumber(lang === 0 ? "라이선스 no" : "License no.");
        setDropGroup(lang === 0 ? "조직 전체" : "All Organizations");
    }, [lang]);

    const droplistLicense = [
        lang === 0 ? "라이선스 상태" : "License Status",
        lang === 0 ? "활성" : "Active",
        lang === 0 ? "만료" : "Expired",
        lang === 0 ? "비활성" : "Inactive"
    ];

    const [boxView, setBoxView] = useState(initialBoxView);
    const [dropViewLicense, setDropViewLicense] = useState(false);
    const [dropViewNumber, setDropViewNumber] = useState(false);
    const [dropViewGroup, setDropViewGroup] = useState(false);
    const [search, setSearch] = useState("");

    // refs for dropdowns to close them on outside click
    const dropLicenseRef = useRef(null);
    const dropNumberRef = useRef(null);
    const dropGroupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropLicenseRef.current && !dropLicenseRef.current.contains(event.target)) {
                setDropViewLicense(false);
            }
            if (dropNumberRef.current && !dropNumberRef.current.contains(event.target)) {
                setDropViewNumber(false);
            }
            if (dropGroupRef.current && !dropGroupRef.current.contains(event.target)) {
                setDropViewGroup(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const droplistGroup = [
        lang === 0 ? "조직 전체" : "All Organizations",
        ...(organization?.teams ?? []).map(team => team.name)
    ];

    const licenseCodes = licenseGroup
        .map(item => item.licenseCode)
        .filter(code => code && code.trim() !== '');
    const uniqueLicenseCodes = Array.from(new Set(licenseCodes));
    const droplistNumber = [lang === 0 ? "라이선스 no" : "License no.", ...uniqueLicenseCodes];

    const licenseCount = licenseGroup.length;
    const useCount = licenseGroup.filter(x => x.user).length;
    const memberCount = organization?.users?.length || 0;
    const searchLower = search.toLowerCase();

    // 검색어가 없으면 true, 있으면 email, 이름, 라이선스 no. 에서 검색어가 포함되었는지 확인
    const filteredList = licenseGroup.filter(item => {
        let groupitem = licenseGroup?.find(item2 => item2?.licenseGroup?.groupId === item?.licenseCode)?.licenseGroup;
        //console.log(item, groupitem);

        const codeMatch = item.licenseCode?.toLowerCase().includes(searchLower);
        const userMatch = item.user
            ? (
                (item.user.email && item.user.email.toLowerCase().includes(searchLower)) ||
                (item.user.fullname && item.user.fullname.toLowerCase().includes(searchLower))
            )
            : false;
        const searchMatch = searchLower ? (codeMatch || userMatch) : true;

        let dropLicenseMatch = true;
        if (dropLicense === (lang === 0 ? '활성' : 'Active')) {
            dropLicenseMatch = new Date(groupitem.expiredAt) > new Date();
        } else if (dropLicense === (lang === 0 ? '비활성' : 'Inactive')) {
            dropLicenseMatch = item.user === null;
        } else if (dropLicense === (lang === 0 ? '만료' : 'Expired')) {
            dropLicenseMatch = new Date(groupitem.expiredAt) < new Date();
        }

        let dropGroupMatch = true;
        if (dropGroup !== (lang === 0 ? '조직 전체' : 'All Organizations')) {
            dropGroupMatch = (item.user?.team?.name === dropGroup);
        }

        let dropNumberMatch = true;
        if (dropNumber !== (lang === 0 ? '라이선스 no' : 'License no.')) {
            console.log("dropNumber : ", dropNumber, ", item.licenseCode : ", item.licenseCode);
            dropNumberMatch = (item.licenseCode === dropNumber);
        }

        return dropLicenseMatch && dropGroupMatch && dropNumberMatch && searchMatch;
    });

    const handleExcelDownload = (e) => {
        e.stopPropagation();
        const csvHeaders = [
            lang === 0 ? "라이선스 no." : "License No.",
            lang === 0 ? "청구옵션" : "Billing Option",
            //lang === 0 ? "조직" : "Organization",
            lang === 0 ? "이름" : "Name",
            lang === 0 ? "계정" : "Account",
            lang === 0 ? "권한" : "Role",
            lang === 0 ? "라이선스 상태" : "License Status"
        ];

        const csvRows = filteredList.map(item => {
            const licenseCode = item.licenseCode || "";
            // const billingOption = item.licenseCode === ''
            //     ? (lang === 0 ? "무료 체험" : "Trial")
            //     : (lang === 0 ? "유료" : "Paid");
            const billingOption = '';
            const organizationName = item.user?.team?.name || "";
            const name = item.user?.fullname || "";
            const account = item.user?.email || "";
            let role = "";
            if (item.user) {
                if (item.licenseGroup?.groupOwner?.some(m => m.id === item.user.id)) {
                    role = "Owner";
                } else if (item.licenseGroup?.groupManager?.some(m => m.id === item.user.id)) {
                    role = "Manager";
                } else {
                    role = "User";
                }
            }
            const today = new Date();
            const revokeDate = item.revokedAt ? new Date(item.revokedAt) : null;
            let status = "";
            if (revokeDate && revokeDate < today) {
                status = lang === 0 ? "만료" : "Expired";
            } else {
                status = item.user === null
                    ? (lang === 0 ? "비활성" : "Inactive")
                    : (lang === 0 ? "활성" : "Active");
            }
            return [licenseCode, billingOption, organizationName, name, account, role, status];
        });

        const csvContent = [csvHeaders, ...csvRows]
            .map(row => row.join(","))
            .join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "licenses.csv");
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const pro = useSelector((s) => s.licenseReducer.pro);
    const art = useSelector((s) => s.licenseReducer.art);
    const all = useSelector((s) => s.licenseReducer.all);

    const checkMember = (data, id) => {
        for (const record of data) {
            const licenseGroup = record.licenseGroup;
            if (licenseGroup) {
                if (
                    licenseGroup.groupOwner &&
                    licenseGroup.groupOwner.some((owner) => owner.id === id)
                ) {
                    return "groupOwner";
                }
                if (
                    licenseGroup.groupManager &&
                    licenseGroup.groupManager.some((manager) => manager.id === id)
                ) {
                    return "groupManager";
                }
            }
        }
        return "none";
    };

    const { mbData } = useSelector((s) => s.usersReducer);
    const check = checkMember([...pro, ...art, ...all], mbData.idx);
    const isOwner = check === "groupOwner";
    const isManager = check === "groupManager";

    const navigate = useNavigate();

    return (
        <div
            className="licensing_box"
            onClick={() => {
                setBoxView(true);
            }}
        >
            <div className={`title_box ${boxView ? 'on' : ''}`}>
                <p className="title">{`UModeler X ${groupName}`}</p>

                {/* {isOwner && <div className="btn_box pc">
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(routes.PlusGroup);
                        }}
                    >
                        {lang === 0 ? "조직/멤버 관리" : "Manage Org/Members"}
                    </button>
                </div>} */}

                {!boxView ? (
                    <img
                        src={require("../assets/icon/arr_down_gray.svg").default}
                        alt="down"
                    />
                ) : (
                    <img
                        src={require("../assets/icon/arr_up_gray.svg").default}
                        alt="up"
                        onClick={(e) => {
                            e.stopPropagation();
                            setBoxView(false);
                        }}
                    />
                )}
            </div>

            {boxView && (
                <>
                    <div className="licensing_info_box">
                        {groupName !== 'Pro' &&
                        <div className="title_box">
                            <div className="title">
                                <p>{lang === 0 ? "라이선스:" : "License:"}</p>
                                <span>{licenseCount}</span>
                                <p>{lang === 0 ? `(사용 ${useCount})` : `(Used ${useCount})`}</p>
                            </div>

                            <span className="line">|</span>

                            <div className="title">
                                <p>{lang === 0 ? "멤버:" : "Members:"}</p>
                                <span>{memberCount}</span>
                                <p>{lang === 0 ? `활성 ${useCount}` : `Active ${useCount}`}</p>
                            </div>
                        </div>}

                        <div className="search_box">
                            {groupName !== 'Pro' &&
                            <>
                            <div
                                className={`drop_box ${dropViewNumber ? 'on' : ''}`}
                                style={{ width: '100%' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setDropViewNumber(!dropViewNumber);
                                }}
                                ref={dropNumberRef}
                            >
                                <span>{dropNumber}</span>
                                {dropViewNumber && (
                                    <div className="drop_list">
                                        {droplistNumber.map((x, i) => (
                                            <p
                                                key={i}
                                                onClick={() => {
                                                    setDropNumber(x);
                                                    setDropViewNumber(false);
                                                }}
                                            >
                                                {x}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div
                                className={`drop_box popup_member_edit ${dropViewGroup ? 'on' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setDropViewGroup(!dropViewGroup);
                                }}
                                ref={dropGroupRef}
                            >
                                <span>{dropGroup}</span>
                                {dropViewGroup && (
                                    <div className="drop_list">
                                        {droplistGroup.map((x, i) => (
                                            <p
                                                key={i}
                                                onClick={() => {
                                                    setDropGroup(x);
                                                    setDropViewGroup(false);
                                                }}
                                            >
                                                {x}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="input_box">
                                <input
                                    type="text"
                                    placeholder={lang === 0 ? "라이선스no, 이메일, 이름" : "License no, email, name"}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <img
                                    src={require("../assets/icon/search_black.svg").default}
                                    alt="search"
                                />
                            </div>
                            </>
                            }

                            <div
                                className={`drop_box license ${dropViewLicense ? 'on' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setDropViewLicense(!dropViewLicense);
                                }}
                                ref={dropLicenseRef}
                            >
                                <span>{dropLicense}</span>
                                {dropViewLicense && (
                                    <div className="drop_list">
                                        {droplistLicense.map((x, i) => (
                                            <p
                                                key={i}
                                                onClick={() => {
                                                    setDropLicense(x);
                                                    setDropViewLicense(false);
                                                }}
                                            >
                                                {x}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {groupName !== 'Pro' &&
                            <>
                            <button
                                type="button"
                                className="pc"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleExcelDownload(e);
                                }}
                                style={{ paddingLeft: '10px', paddingRight: '10px' }}
                            >
                                <img
                                    src={require("../assets/icon/excel.svg").default}
                                    alt="excel"
                                />
                                {lang === 0 ? "엑셀다운로드" : "Download Excel"}
                            </button>

                            <button
                                type="button"
                                className="mobile"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleExcelDownload(e);
                                }}
                            >
                                <img
                                    src={require("../assets/icon/excel.svg").default}
                                    alt="excel"
                                />
                            </button>
                            </>
                            }
                        </div>
                    </div>

                    <PaginationLicense
                        coupon={filteredList}
                        search={search}
                        dropLicense={dropLicense}
                        dropGroup={dropGroup}
                        dropNumber={dropNumber}
                        view={view}
                        payList={payList}
                        subscribelist={subscribelist}
                        payinfolists={payinfolists}
                    />
                </>
            )}
        </div>
    );
}

export default ProductBox;